import { render } from "./ticketsManage.vue?vue&type=template&id=38a87eea"
import script from "./ticketsManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ticketsManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/ticketsManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38a87eea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38a87eea', __exports__)) {
    console.log('reload')
    api.reload('38a87eea', __exports__)
  }
  
  module.hot.accept("./ticketsManage.vue?vue&type=template&id=38a87eea", () => {
    console.log('re-render')
    api.rerender('38a87eea', render)
  })

}


export default __exports__